import { Model, type ModelProps } from '@/infra/model'
import { computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'
import { toStream } from '@/utils/mobx-util'

/**
 * Props for {@link PersonalTaxRefundMethodSupportingItemInput}.
 */
export type PersonalTaxRefundMethodSupportingItemInputProps =
  ModelProps<PersonalTaxRefundMethodSupportingItemInput> & {
    type: 'PersonalTaxRefundMethod'
  }

/**
 * Supporting item input for a personal tax refund method.
 */
export class PersonalTaxRefundMethodSupportingItemInput
  extends Model<PersonalTaxRefundMethodSupportingItemInput>
  implements SupportingItemInputBase
{
  /**
   * The provided personal tax refund method, if any.
   */
  @observable.struct accessor provided: ProvidedPersonalTaxRefundMethod | null =
    null

  /**
   * Stream of changes to the provided personal tax refund method.
   */
  readonly providedChanges$ = toStream(() => this.provided)

  /** @inheritDoc */
  @computed get isCompleted() {
    return !!this.provided
  }
}

/**
 * A provided personal tax refund method.
 */
export interface ProvidedPersonalTaxRefundMethod {
  readonly refundMethodId: string
  readonly refundMethodVersion: number
}
